// PT1 — elemental cross-reactions (build-synergy depth). Pure, deterministic number helpers; the combat
// layer applies them on kill, gated on a catalyst item so default builds (and the balance canary) are
// unaffected — exactly like MP4's frost shatter (Frozen Heart). Two new reactions:
//   • Combust  (catalyst Ember Core)   — a BURNING enemy that dies bursts a fire nova: AoE damage + spreads burn.
//   • Contagion(catalyst Fungal Spores)— a POISONED enemy that dies releases spores: spreads poison to the swarm.

export interface CombustNova {
  radius: number
  damage: number
  burnTime: number
  burnDps: number
}
/** Fire nova from a dying burning enemy — scales with the burn it was carrying + a slice of its max HP. */
export function combustNova(maxHp: number, burnDps: number): CombustNova {
  return {
    radius: 2.6,
    damage: Math.max(8, burnDps * 1.5 + Math.max(0, maxHp) * 0.04),
    burnTime: 2.5,
    burnDps: Math.max(5, burnDps * 0.6),
  }
}

export interface ConductionArc {
  radius: number
  damage: number
}
/** PT1b — Conduction (catalyst Capacitor): a weapon CRIT arcs bonus lightning to the nearest other foe
 * for a fraction of the hit. Crit-gated so it's a build payoff, not every-hit spam. */
export function conductionArc(hitAmount: number): ConductionArc {
  return { radius: 5.5, damage: Math.max(4, hitAmount * 0.5) }
}

export interface ContagionCloud {
  radius: number
  poisonTime: number
  poisonDps: number
}
/** Spore cloud from a dying poisoned enemy — re-seeds poison on nearby foes (the plague spreads). */
export function contagionCloud(poisonDps: number): ContagionCloud {
  return {
    radius: 2.8,
    poisonTime: 3,
    poisonDps: Math.max(5, poisonDps * 0.7),
  }
}
